import styled from 'theme';

export const RequiredNotice = styled.div`
  color: ${(p) => p.theme.colors.red};
`;
